export enum DemoInvoiceFinalizeAction {
  DownloadAsPdf = 'downloadAsPdf',
  SendAsEInvoice = 'sendAsEInvoice',
  SendAsEmail = 'sendAsEmail',
}
